import { TimesheetsTableHeaderCell } from '../Cells/TimesheetsTableHeaderCell';
import { TableRowHeader } from '../Rows/styles/TimesheetsHeaderRow.styled';

interface TimeSheetsHeaderRowProps {
  headerData?: {
    title: string;
    new_date: string;
  }[];
  headerTitle?: string;
}

export const MobileTimeSheetsHeaderRow = ({
  headerData,
  headerTitle,
}: TimeSheetsHeaderRowProps) => {
  return (
    <TableRowHeader>
      {headerTitle && (
        <TimesheetsTableHeaderCell
          title={headerTitle ?? headerData[0].title}
          index={0}
          key={0}
        />
      )}
      {headerData
        ? headerData.map((cell, index) => {
            if (index !== 0) {
              return (
                <TimesheetsTableHeaderCell
                  key={cell.title}
                  title={cell.title}
                  index={index}
                  date={cell.new_date}
                />
              );
            }
          })
        : null}
    </TableRowHeader>
  );
};
